(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/hero.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/hero.js');
'use strict';

const PriceLabel = svs.tickets.next.components.nova.PriceLabel;
const PriceLabelCurrency = svs.tickets.next.components.nova.PriceLabelCurrency;
const Callout = svs.tickets.next.components.nova.Callout;
const getCalloutLines = svs.tickets.next.utils.utils.getCalloutLines;
const getImageAspectRatio = function () {
  let image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const width = Number(image === null || image === void 0 ? void 0 : image.width);
  const height = Number(image === null || image === void 0 ? void 0 : image.height);
  if (Number.isFinite(width) && Number.isFinite(height) && height > 0) {
    return width / height;
  }
  return 1;
};
const usePriceLabelSize = function () {
  let map = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    xs: 'sm',
    sm: 'md',
    am: 'md',
    md: 'md',
    lg: 'lg',
    xl: 'lg'
  };
  const breakpoint = svs.tickets.next.hooks.useBreakpoints();
  return map[breakpoint] || 'md';
};
const Hero = _ref => {
  var _svs$tickets$data$mod, _heroTicket$skins;
  let heroTicket = _ref.heroTicket,
    onSelectProduct = _ref.onSelectProduct;
  const priceLabelSize = usePriceLabelSize();
  if (!heroTicket) {
    return null;
  }
  const ImageMemo = svs.tickets.next.components.ImageMemo;
  const TicketWithPodiumShadow = svs.tickets.next.components.TicketWithPodiumShadow;
  const AnimatedBackgrounds = svs.tickets.next.components.animatedBackground.AnimatedBackgrounds;
  const callOutLabel = (_svs$tickets$data$mod = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod === void 0 || (_svs$tickets$data$mod = _svs$tickets$data$mod.heroTicket) === null || _svs$tickets$data$mod === void 0 ? void 0 : _svs$tickets$data$mod.callout;
  const callOutLines = getCalloutLines(callOutLabel);
  const imageData = (_heroTicket$skins = heroTicket.skins) === null || _heroTicket$skins === void 0 || (_heroTicket$skins = _heroTicket$skins[0]) === null || _heroTicket$skins === void 0 ? void 0 : _heroTicket$skins.image;
  const imageAspectRatio = getImageAspectRatio(imageData);
  const ticketLabel = heroTicket.name || heroTicket.type;
  const ticketAriaLabel = heroTicket.price ? "V\xE4lj ".concat(ticketLabel, ", ").concat(heroTicket.price, " kronor") : "V\xE4lj ".concat(ticketLabel);
  const ariaLabel = callOutLines.length > 0 ? "".concat(ticketAriaLabel, ". ").concat(callOutLines.join(' ')) : ticketAriaLabel;
  const handleSelectProduct = event => {
    event.preventDefault();
    onSelectProduct(heroTicket);
  };
  return React.createElement("div", {
    className: "tickets-next-hero"
  }, React.createElement("div", {
    "aria-hidden": "true",
    className: "tickets-next-hero__background"
  }, React.createElement(AnimatedBackgrounds, {
    ticketInfo: heroTicket
  })), React.createElement("div", {
    className: "tickets-next-hero__content"
  }, React.createElement("a", {
    "aria-label": ariaLabel,
    className: "qa-tickets-next-hero-ticket tickets-next-hero__ticket",
    href: "#",
    onClick: handleSelectProduct
  }, React.createElement(ImageMemo, {
    cssSelectors: "tickets-next-hero-image",
    fitWrapper: false,
    image: imageData
  }), React.createElement(PriceLabel, {
    className: "u-position-absolute tickets-next-hero-price-label",
    edge: "trailing",
    size: priceLabelSize,
    variant: "primary"
  }, React.createElement(PriceLabelCurrency, {
    price: heroTicket.price
  })), React.createElement(Callout, {
    "aria-hidden": "true",
    className: "tickets-next-hero-callout",
    label: callOutLabel
  })), React.createElement("div", {
    className: "tickets-next-hero__podium"
  }, React.createElement(TicketWithPodiumShadow, {
    aspectRatio: imageAspectRatio,
    opacity: 0.7,
    translateY: "0%"
  }))));
};
setGlobal('svs.tickets.next.components.Hero', Hero);

 })(window);